document.addEventListener("DOMContentLoaded", function (event) {
  const bodyContainer = document.querySelector("body");

  const cartDrawer = document.querySelector(".cart-drawer");
  const cartBackground = document.querySelector(".cart-drawer__background");
  const cartEmpty = document.querySelector(".cart-empty");
  const upsell = document.querySelector(".swiper-content");

  // Check if gamification features are enabled
  const isGamificationEnabled = document.querySelector('.progress-bar-container') !== null;
  const isOldGamificationEnabled = document.querySelector('.cart-drawer__gamification') !== null;

  const gamification = (totalValue) => {

    if (!isOldGamificationEnabled) return;

    let totalPrice = totalValue / 100;
    let sum = 75 - totalPrice;
    sum = parseFloat(sum.toFixed(2)); 

    const progress = document.querySelector(".progress");
    //const iconShipping = document.querySelector(".cart-drawer__gamification-progress .icon-shipping");
    const gamificationMessage = document.querySelector(
      ".cart-drawer__gamification h2"
    );

    const percentage = (totalPrice / 75) * 100;
    const progressPercentage = Math.min(percentage, 100);

    if (totalPrice < 75){
      progress.style.width = `${progressPercentage}%`;
      //iconShipping.classList.remove("complete");
    } else {
      progress.style.width = "100%";
      //iconShipping.classList.add("complete");
    }

    if (totalPrice >= 75) {
      gamificationMessage.innerHTML =
        "Congrats! You've unlocked <strong>Free Shipping! </strong>";
    } else {
      gamificationMessage.innerHTML = `Add $${sum} and get <strong>Free Shipping!</strong>`;
    }

    if (totalPrice === 0) {
      progress.style.width = "0%";
      //iconShipping.classList.remove("complete");
    }
  };
  const updateGamificationProgress = (cart) => {

    if (!isGamificationEnabled) return;

    const progressBarContainer = document.querySelector('.progress-bar-container');
    if (!progressBarContainer) return;

    const calculated_total_price = cart.original_total_price;
    const level = progressBarContainer.getAttribute('data-level');

    // Obtain discount values
    const secondDiscount = parseFloat(progressBarContainer.getAttribute('data-second-discount') || '0');
    const thirdDiscount = parseFloat(progressBarContainer.getAttribute('data-third-discount') || '0');
    console.log("Discount--Gamification", secondDiscount, thirdDiscount);
    
    // Calculate the final price with discounts if any
    let calculatedDiscountPrice = cart.original_total_price;
    const threshold2 = parseInt(progressBarContainer.getAttribute('data-threshold-2'));
    const threshold3 = parseInt(progressBarContainer.getAttribute('data-threshold-3'));
    const threshold4 = parseInt(progressBarContainer.getAttribute('data-threshold-4'));

    const enable_fourth_threshold = progressBarContainer.getAttribute('data-enable-fourth-threshold') === "true";
    const enable_third_threshold = progressBarContainer.getAttribute('data-enable-third-threshold') === "true";
    const enable_second_threshold = progressBarContainer.getAttribute('data-enable-second-threshold') === "true";
    
    const text_status_second_treshold = progressBarContainer.getAttribute('data-text-status-second-threshold');
    const text_status_third_treshold = progressBarContainer.getAttribute('data-text-status-third-threshold');
    const text_status_fourth_treshold = progressBarContainer.getAttribute('data-text-status-fourth-threshold');

    // Get the names of thresholds
    const secondThresholdText = progressBarContainer.querySelector('.second-threshold')?.textContent.trim();
    const thirdThresholdText = progressBarContainer.querySelector('.third-threshold')?.textContent.trim();
    const fourthThresholdText = progressBarContainer.querySelector('.fourth-threshold')?.textContent.trim();

    // Update percentage of progress
    let percentage1 = 0;
    let percentage2 = 0;
    let percentage3 = 0;

    if (calculated_total_price <= threshold2) {
      const progress = (calculated_total_price / threshold2) * 100;
      percentage1 = Math.min(progress, 100);
    } else if (calculated_total_price <= threshold3) {
      percentage1 = 100;
      const progress = ((calculated_total_price - threshold2) / (threshold3 - threshold2)) * 100;
      percentage2 = Math.min(progress, 100);
    } else if (calculated_total_price <= threshold4) {
      percentage1 = 100;
      percentage2 = 100;
      const progress = ((calculated_total_price - threshold3) / (threshold4 - threshold3)) * 100;
      percentage3 = Math.min(progress, 100);
    } else {
      percentage1 = 100;
      percentage2 = 100;
      percentage3 = 100;
    }

    // Update progress status text
    const progressStatus = document.querySelector('.progress-status');
    if (progressStatus) {
        if (calculated_total_price < threshold2) {
            const amountNeeded = (threshold2 - calculated_total_price) / 100;
            progressStatus.innerHTML = `You are <strong>$${amountNeeded.toFixed(2)}</strong> away from <strong>${text_status_second_treshold}</strong>`;
        } else if (enable_third_threshold && calculated_total_price < threshold3) {
            const amountNeeded = (threshold3 - calculated_total_price) / 100;
            progressStatus.innerHTML = `You are <strong>$${amountNeeded.toFixed(2)}</strong> away from <strong>${text_status_third_treshold}</strong>`;
        } else if (enable_fourth_threshold == true && calculated_total_price < threshold4) {
            const amountNeeded = (threshold4 - calculated_total_price) / 100;
            progressStatus.innerHTML = `You are <strong>$${amountNeeded.toFixed(2)}</strong> away from <strong>${text_status_fourth_treshold}</strong>`;
        } else {

          let lastThresholdText;

          if (enable_second_threshold && text_status_second_treshold) lastThresholdText = text_status_second_treshold;
          if (enable_third_threshold && text_status_third_treshold) lastThresholdText = text_status_third_treshold;
          if (enable_fourth_threshold && text_status_fourth_treshold) lastThresholdText = text_status_fourth_treshold;
          
          progressStatus.innerHTML = lastThresholdText 
              ? `You're getting <strong>${lastThresholdText}</strong>!`
              : '';
        }
    }
    // Update progress bars
    const progressLines = document.querySelectorAll('.progress-line');
    if (progressLines.length > 0) progressLines[0].style.setProperty('--progress', `${percentage1}%`);
    if (progressLines.length > 1) progressLines[1].style.setProperty('--progress', `${percentage2}%`);
    if (progressLines.length > 2) progressLines[2].style.setProperty('--progress', `${percentage3}%`);

    // Update active statuses
    const steps = document.querySelectorAll('.progress-step');
    steps.forEach((step, index) => {
      if (index < Math.ceil(Math.max(percentage1, percentage2, percentage3) / 25)) {
        step.classList.add('active');
      } else {
        step.classList.remove('active');
      }
    });

    const thresholdSteps = document.querySelectorAll('.progress-step-t');
    thresholdSteps.forEach((step, index) => {
      let percentageToCheck;
      if (index === 0) percentageToCheck = percentage1;
      if (index === 1) percentageToCheck = percentage2;
      if (index === 2) percentageToCheck = percentage3;
  
      if (percentageToCheck >= 100) {
        step.classList.add('active');
      } else {
        step.classList.remove('active');
      }
    });
  };
  let productChecked = false; // Variable to avoid unnecessary multiple attempts

  const getCart = () => {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        if (cart) {
          if (isGamificationEnabled) {
            updateGamificationProgress(cart);
            handleThresholdGifts(cart);
          }

          if (isOldGamificationEnabled) {
            gamification(cart.total_price);
          }

          if(cart.items.length >= 3) {
            document.querySelector(".swiper-content").classList.add("remove-position");
          } else {
            document.querySelector(".swiper-content").classList.remove("remove-position");
          }

          if (cart.items.length > 0) {
            cartDrawer.classList.remove("empty");
            cartEmpty.classList.add("hide");
            upsell.classList.add("show");
            
          } else {
            cartDrawer.classList.add("empty");
            cartEmpty.classList.remove("hide");
            upsell.classList.remove("show");
          }

          if (cart.items.length >= 1) {
            document
              .querySelector(".cart-drawer__items")
              .classList.add("scroll");
          } else {
            document
              .querySelector(".cart-drawer__items")
              .classList.remove("scroll");
          }

          // document.querySelector(".navbar-toggler__cart").innerHTML = `(${cart.item_count})`;
          document.querySelector(
            ".cart-drawer__header span"
          ).innerHTML = `<span>Your Cart <span class="count">(${cart.item_count} Item)</span></span>`;

          document.querySelector(".cartItemCountHeader").innerHTML =
            cart.item_count;

          // document.querySelector(".bag-link").innerHTML = `Bag (${cart.item_count})`;
          document.querySelector(".total-cart").innerHTML = `$${(
            cart.total_price / 100
          ).toFixed(2)}`;

          const cartItems = cart.items
            .map((item) => {
              const is_free = item.variant_id === 41530456375409 ? true : false;
              return `
							<div id="${item.title}" class="cart-drawer__body-item  product-${item.handle}">
								<div class="cart-drawer__body-item-image">
                <a href="${item.url}">
									<img src="${item.image}" alt="${item.title}">
                </a>
								</div>
								<div class="cart-drawer__body-item-product">
									<div class="cart-drawer__body-item-product-heading">
										<a href="${item.url}">
                    <h3>
                      ${item.product_title}

                      <span>${item.variant_title ? item.variant_title : ''}</span>
                    </h3>
                    </a>
										<span>$${(item.line_price / 100).toFixed(2)}</span>
									</div>
									<div class="cart-drawer__body-item-product-actions ${is_free && 'is-free'}">
										<div class="cart-qty">
											<span class="qty-down" data-variant-id="${item.id}" data-current-quantity="${
                item.quantity
              }">-</span>
											<span class="quantity">${item.quantity}</span>
											<span class="qty-up" data-variant-id="${item.id}" data-current-quantity="${
                item.quantity
              }">+</span>
										</div>
										<div class="remove">
											<span class="remove-lineitem" data-name="${item.title}" data-variant-id="${
                item.id
              }"><svg class="remove-from-svg" data-variant-id="${
                item.id
              }" width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M13.1565 5.19996L12.6174 15.2521C12.6 15.6173 12.2869 15.913 11.9217 15.913H3.12172C2.7565 15.913 2.44346 15.6173 2.42607 15.2521L1.88694 5.19996C1.86954 4.81735 2.1652 4.48691 2.5478 4.46952C2.93041 4.45213 3.26085 4.74778 3.27824 5.13039L3.78259 14.5217H11.2782L11.7826 5.13039C11.8 4.74778 12.1304 4.45213 12.513 4.46952C12.8782 4.48691 13.1739 4.81735 13.1565 5.19996ZM15 2.86952C15 3.25213 14.6869 3.56517 14.3043 3.56517H0.739109C0.356501 3.56517 0.043457 3.25213 0.043457 2.86952C0.043457 2.48691 0.356501 2.17387 0.739109 2.17387H4.5652V0.608653C4.5652 0.278218 4.79128 0.0869141 5.12172 0.0869141H9.92172C10.2522 0.0869141 10.4782 0.278218 10.4782 0.608653V2.17387H14.3043C14.6869 2.17387 15 2.48691 15 2.86952ZM5.78259 2.17387H9.26085V1.30431H5.78259V2.17387ZM6.07824 13.4782C6.42607 13.4782 6.68694 13.1478 6.68694 12.8173L6.51302 5.30431C6.51302 4.97387 6.23476 4.69561 5.88694 4.69561C5.5565 4.69561 5.27824 4.97387 5.29563 5.3217L5.46954 12.8521C5.46954 13.1826 5.74781 13.4782 6.07824 13.4782ZM8.94781 13.4782C9.27824 13.4782 9.5565 13.2 9.5565 12.8695L9.73041 5.35648C9.73041 5.02604 9.46954 4.73039 9.13911 4.73039C8.79128 4.73039 8.53041 4.99126 8.51302 5.3217L8.33911 12.8347C8.32172 13.1826 8.59998 13.4782 8.94781 13.4782C8.93041 13.4782 8.93041 13.4782 8.94781 13.4782Z" fill="#151515"/>
											</svg>
											 Remove</span>
										</div>
									</div>
								</div>
							</div>`;
            })
            .join("");

          document.querySelector(".cart-drawer__items").innerHTML = cartItems;

          const itemsInCart = cart.items;
          let productOneInCart = false;
          let productTwoInCart = false;
          let productThreeInCart = false;

          itemsInCart.forEach(item => {
            if (item.id === 39955132317809) {
              productOneInCart = true;
            }
            if (item.id === 39893736325233) {
              productTwoInCart = true;
            }
            if (item.id === 39893736358001) {
              productThreeInCart = true;
            }
          })

          if (productOneInCart && !productTwoInCart && !productThreeInCart){
            getProductUpsell("life-of-the-party");
          }
        }
      });
  };

  // Function to manage gifts by threshold
const handleThresholdGifts = async (cart) => {
  const progressBarContainer = document.querySelector('.progress-bar-container');
  if (!progressBarContainer) {
    return;
  }

  const enable_third_gift = progressBarContainer.getAttribute('data-enable-third-gift') === 'true';
  const enable_fourth_gift = progressBarContainer.getAttribute('data-enable-fourth-gift') === 'true';
  const third_gift_id = progressBarContainer.getAttribute('data-third-gift-id');
  const fourth_gift_id = progressBarContainer.getAttribute('data-fourth-gift-id');
  const third_gift_amount = parseInt(progressBarContainer.getAttribute('data-third-gift-amount'));
  const fourth_gift_amount = parseInt(progressBarContainer.getAttribute('data-fourth-gift-amount'));

  const cartItems = cart.items;
  const currentTotal = cart.total_price;

  // Handle third threshold gift
  if (enable_third_gift && third_gift_id) {
    const hasThirdGift = cartItems.find(item => 
      item.variant_id.toString() === third_gift_id &&
      item.properties && item.properties._gift_threshold === 'third'
    );

    if (currentTotal >= third_gift_amount) {
      if (!hasThirdGift) {
        await addGiftToCart(third_gift_id, 'third');
      }
    } else if (hasThirdGift) {
      await removeGiftFromCart(third_gift_id);
    }
  }

  // Handling fourth threshold gift
  if (enable_fourth_gift && fourth_gift_id) {
    const hasFourthGift = cartItems.find(item => 
      item.variant_id.toString() === fourth_gift_id &&
      item.properties && item.properties._gift_threshold === 'fourth'
    );

    if (currentTotal >= fourth_gift_amount) {
      if (!hasFourthGift) {
        await addGiftToCart(fourth_gift_id, 'fourth');
      }
    } else if (hasFourthGift) {
      await removeGiftFromCart(fourth_gift_id);
    }
  }
};

// Add an interval check to periodically verify gift conditions
const startGiftCheck = () => {
  setInterval(async () => {
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();
      await handleThresholdGifts(cart);
    } catch (error) {
      console.error('Error checking cart status:', error);
    }
  }, 2000);
};
// Add gift to cart function
const addGiftToCart = async (variantId, threshold) => {
  try {
    const formData = {
      items: [{
        id: variantId,
        quantity: 1,
        properties: {
          '_gift': true,
          '_gift_threshold': threshold,
          '_is_free': true
        }
      }]
    };

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    });

    if (!response.ok) throw new Error('Error adding gift');
     getCart();
    return response.json();
  } catch (error) {
    console.error('Error adding gift to cart:', error);
  }
};

// Function to remove gift from cart
const removeGiftFromCart = async (variantId) => {
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 0
      })
    });

    if (!response.ok) throw new Error('Error removing gift');
    getCart();
    return response.json();
  } catch (error) {
    console.error('Error removing gift from cart:', error);
  }
};
// Initialize the gift check interval when the document is ready
document.addEventListener('DOMContentLoaded', startGiftCheck);

  //Add product from cart side function
    
  async function addElementCartFromUpsell(variantId){
  
    let formData = {
      items: [
        {
          id: variantId,
          quantity: 1 
        }
      ]
    }; 
  
    await fetch("/cart/add.js", {
        method: "post",
        headers: {
            'Content-Type': 'application/json'
          },
        body: JSON.stringify(formData),
    })
    .then(response => {
      return response.json();
    })
    .then(data => {
      console.log('Product added to cart:', data);
      getCart();
    })
    .catch((error) => {
      console.error('Error:', error);
    })
  }



  async function getProductUpsell(handle){
  
    await fetch(`/products/${handle}.js`)
    .then(response => response.json())
    .then(product => {
      
        const selected_variant = product.variants[0];
        const second_variant = product.variants[1];
        const image = product.variants[1].featured_image.src;
        const title = product.title;
        const url = product.url;
        const variant = product.variants[1];
        const titleVariant = variant.title;
        const price = (variant.price / 100).toFixed(2);
        const priceDiscount = ((variant.price*0.9) / 100).toFixed(2);

        const bannerUpsell = `
          <div class="container-upsell-cart">
          <!-- Primera sección -->
          <div class="section-one-upsell-cart">
            <div class="title-container-upsell-cart">
              <h1 class="title-upsell-cart">You added a Discovery Kit!</h1>
            </div>
            <p class="description-upsell-cart">
              <strong>CONGRATS! </strong>You unlocked <strong>10% OFF</strong> on <strong>Life of The Party!</strong>
            </p>
          </div>

          <!-- Segunda secciónn -->
          <div class="section-two-upsell-cart">
            <a href="${url}">
              <img src="${image}" alt="${title}" class="product-image-upsell-cart">
            </a>
            <div class="product-info-upsell-cart">
            <a href="${url}">
              <h2 class="product-title-upsell-cart">${title}</h2>
            </a>
              <div class="product-size-upsell-cart">
                <div class="product-specific-size-upsell-cart product-specific-big-size-upsell-cart" data-image="${selected_variant.featured_image.src}" data-price="$${(selected_variant.price/100).toFixed(2)}" data-discount-price="$${((selected_variant.price/100)*0.9).toFixed(2)}">
                  <svg width="12" height="23" viewBox="0 0 12 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_16973_118)">
                  <path d="M8.78814 4.50561L3.23286 4.5L3.22752 9.79347C3.22752 9.79347 3.6063 10.586 3.22645 10.8522C2.69809 11.2223 1.00353 11.3793 1.00199 12.9673L0.999857 15.0847C0.996831 18.0843 0.993679 21.0134 0.993185 21.4368C0.992693 21.8603 0.992095 22.4955 2.1036 22.4966L9.88099 22.5045C10.9911 22.5056 10.9921 21.9772 10.9931 21.4483V21.4469C10.9969 17.7415 11.0013 13.5763 11.0017 12.9774C11.0028 11.3893 9.07169 11.1346 8.78173 10.8578C8.33774 10.4338 8.78262 9.97552 8.7828 9.79907L8.78814 4.50561Z" fill="black"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_16973_118">
                  <rect width="12" height="22" fill="white" transform="translate(0 0.5)"/>
                  </clipPath>
                  </defs>
                  </svg>
                  <p class="text-product-specific-big-size-upsell-cart text-product-specific-big-size-upsell-30ml-cart">${selected_variant.title}</p>
                </div>
                
                <div class="product-specific-size-upsell-cart product-specific-small-size-upsell-cart" data-image="${second_variant.featured_image.src}" data-price="$${(second_variant.price/100).toFixed(2)}" data-discount-price="${((second_variant.price/100)*0.9).toFixed(2)}">
                  <svg width="4" height="23" viewBox="0 0 4 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_16996_125)">
                  <path d="M4 0.5H0V5.76087C1.69101 6.13838 2.39788 6.17605 4 5.76087V0.5Z" fill="black"/>
                  <path d="M4 6.53418C2.51017 6.87178 1.64064 6.85148 0 6.53418V22.5H4V6.53418Z" fill="black"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_16996_125">
                  <rect width="4" height="22" fill="black" transform="translate(0 0.5)"/>
                  </clipPath>
                  </defs>
                  </svg>
                  <p class="text-product-specific-small-size-upsell-cart text-product-specific-small-size-upsell-10ml-cart">${second_variant.title}</p>
                </div>
              </div>
              <button class="button-upsell-and-price-cart button-upsell-and-price-30ML-cart" type="button">
                <p class="title-button-cart">ADD TO BAG</p>
                <div class="upsell-discount-price-cart">
                  <p class="original-price-cart">$${(selected_variant.price/100).toFixed(2)}</p>
                  <p class="discount-price-cart">$${((selected_variant.price/100)*0.9).toFixed(2)}</p>
                </div>
              </button>
            </div>
          </div>
        </div>
        `;

        document.querySelector(".cart-drawer__items").innerHTML += bannerUpsell;
        document.querySelector(".swiper-content").classList.add("remove-position");

    })
    .catch(error => {
        console.error('Error al obtener el producto:', error);
    });

    const buttonAddUpsell = document.querySelector(".button-upsell-and-price-cart");
    const buttonBigSizeUpsell = document.querySelector(".product-specific-big-size-upsell-cart");
    const buttonSmallSizeUpsell = document.querySelector(".product-specific-small-size-upsell-cart");
    const buttonBigSizeUpsell30ML = document.querySelector(".text-product-specific-big-size-upsell-30ml-cart");
    const buttonSmallSizeUpsell10ML = document.querySelector(".text-product-specific-small-size-upsell-10ml-cart");
    const originalPrice = document.querySelector(".original-price-cart");
    const discountPrice = document.querySelector(".discount-price-cart");
    const imageUpsell = document.querySelector(".product-image-upsell-cart");
  
    buttonBigSizeUpsell.style.paddingTop = '1px';
    buttonBigSizeUpsell.style.borderBottom = 'solid 1px rgba(255,255,255,1)';
    
    buttonBigSizeUpsell.addEventListener('click', () => {
  
      buttonBigSizeUpsell.style.paddingTop = '1px';
      buttonBigSizeUpsell.style.borderBottom = 'solid 1px rgba(255,255,255,1)';
  
      buttonSmallSizeUpsell.style.paddingTop = '';
      buttonSmallSizeUpsell.style.borderBottom = '';
  
      buttonBigSizeUpsell30ML.style.fontWeight = "600";
      buttonSmallSizeUpsell10ML.style.fontWeight = "400";
  
      upsellProduct.id = 39893736325233;
  
      const priceValue = buttonBigSizeUpsell.getAttribute('data-price');
      const discountValue = buttonBigSizeUpsell.getAttribute('data-discount-price');
      const imageVariant = buttonBigSizeUpsell.getAttribute('data-image');
  
      originalPrice.textContent = priceValue;
      discountPrice.textContent = discountValue;
      imageUpsell.src = imageVariant;
  
      buttonAddUpsell.classList.add('button-upsell-and-price-30ML-cart');
      buttonAddUpsell.classList.remove('button-upsell-and-price-10ML-cart');
    });  
    
    buttonSmallSizeUpsell.addEventListener('click', () => {
      
      buttonSmallSizeUpsell.style.paddingTop = '1px';
      buttonSmallSizeUpsell.style.borderBottom = 'solid 1px rgba(255,255,255,1)';
  
      buttonBigSizeUpsell.style.paddingTop = '';
      buttonBigSizeUpsell.style.borderBottom = '';
  
      buttonBigSizeUpsell30ML.style.fontWeight = "400";
      buttonSmallSizeUpsell10ML.style.fontWeight = "600";
  
      upsellProduct.id = 39893736358001;
  
      const priceValue = buttonSmallSizeUpsell.getAttribute('data-price');
      const discountValue = buttonSmallSizeUpsell.getAttribute('data-discount-price');
      const imageVariant = buttonSmallSizeUpsell.getAttribute('data-image');
  
      originalPrice.textContent = priceValue;
      discountPrice.textContent = discountValue;
      imageUpsell.src = imageVariant;
  
      buttonAddUpsell.classList.remove('button-upsell-and-price-30ML-cart');
      buttonAddUpsell.classList.add('button-upsell-and-price-10ML-cart');
    });

  }


  const cartOpen = () => {
    cartDrawer.classList.add("show");
    bodyContainer.classList.add("cart-open")
    document.querySelector(".swiper-content").classList.add("show");
    cartBackground.classList.add("active");
    getCart();
  };

  const cartClose = () => {
    console.log('Desde cart close')
    cartDrawer.classList.remove("show");
    cartBackground.classList.remove("active");
    bodyContainer.classList.remove("cart-open")
  };

  cartBackground.addEventListener("click", () => {
    cartClose();
  });

  const addToCart = (variantId = null, quantity = 1, free) => {
    let formData;
    
    if (variantId) {
      // For addToCartProductGift or any other specific item
      formData = { items: [{ id: variantId, quantity: quantity }] };
    } else {
      // For regular addToCart from form
      const form = document.getElementById("product-form");
      const value = form.querySelector('input[name="id"]').value;
      const qty = form.querySelector(".qty-value").value;
      formData = { items: [{ id: value, quantity: qty }] };
    }
    
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data?.status === 422) {
          return;
        }
        cartOpen();
        //getCart();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const changeCartItem = (quantity, variantId) => {
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: `quantity=${encodeURIComponent(quantity)}&id=${encodeURIComponent(
        variantId
      )}`,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data?.status === 422) {
          notify();
          return;
        }
        getCart();
        updateGamificationProgress(data); // Actualizar inmediatamente después del cambio
      });
  };

  const addToCartByVariantId = (formData) => {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data?.status === 422) {
          return;
        }
        cartOpen();
        //getCart();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  document.querySelectorAll(".add-to-cart").forEach((item) => {
    item.addEventListener("click", function (e) {
      e.preventDefault();
      addToCart();
    });
  });

  bodyContainer.onclick = ({ target }) => {

    if(target.classList.contains("upsell-add-to-cart")) {
      const variant_id = target.getAttribute("data-variant");
      const formData = { items: [{ id: variant_id , quantity: 1 }] };
      addToCartByVariantId(formData);
      getCart();
    }

    if (target.classList.contains("qty-selector-pdp")) {
      const value = document.querySelector(".qty-value").value;
      document.querySelector(".qty-value").setAttribute("value", value);
    }

    if (target.classList.contains("atc-plp__button")) {
      target.parentNode.parentNode.parentNode
        .querySelectorAll("input")
        .forEach((element) => {
          if (element.checked) {
            const formData = { items: [{ id: element.value, quantity: 1 }] };
            addToCartByVariantId(formData);
          }
        });
    }
    if (
      target.classList.contains("bag-link") ||
      target.classList.contains("navbar-toggler__cart")
    ) { 
      cartOpen();
    }

    if (target.classList.contains("remove-from-svg")) {
      changeCartItem(0, target.getAttribute("data-variant-id"));
    }

    if (target.classList.contains("remove-lineitem")) {
      changeCartItem(0, target.getAttribute("data-variant-id"));
    }
    if (target.classList.contains("qty-up")) {
      const qty = parseInt(target.getAttribute("data-current-quantity"));
      changeCartItem(qty + 1, target.getAttribute("data-variant-id"));
    }

    if (target.classList.contains("qty-down")) {
      const qty = parseInt(target.getAttribute("data-current-quantity"));
      changeCartItem(
        Math.max(0, qty - 1),
        target.getAttribute("data-variant-id")
      );
    }

    
    if (target.classList.contains("button-upsell-and-price-10ML-cart")){
      console.log('Agregando complemento')
        const upsellProduct = {
          id: 39893736358001,
        }    
        addElementCartFromUpsell(upsellProduct.id)
    }

    if (target.classList.contains("button-upsell-and-price-30ML-cart")){
      console.log('Agregando complemento')
        const upsellProduct = {
          id: 39893736325233,
        }    
        addElementCartFromUpsell(upsellProduct.id)
    }

    
    if (target.classList.contains("button-upsell-and-price-10ML")){
      console.log('Agregando complemento 10ML desde PDP')
        const upsellProduct = {
          id: 39893736358001,
        }    
        addElementCartFromUpsell(upsellProduct.id)
        cartOpen();
    }

    if (target.classList.contains("button-upsell-and-price-30ML")){
      console.log('Agregando complemento 30ML desde PDP')
        const upsellProduct = {
          id: 39893736325233,
        }    
        addElementCartFromUpsell(upsellProduct.id)
        cartOpen();
    }

    if (
      target.classList.contains("close-btn") ||
      target.classList.contains("close-btn-empty")
    ) {
      cartClose();
    }
  };

  if (document.querySelector(".floating-atc__select")) {
    document
      .querySelector(".floating-atc__select")
      .addEventListener("change", (e) => {
        document.querySelector('input[name="id"]').value = e.target.value;
      });

    document
      .querySelector(".floating-atc__button")
      .addEventListener("click", () => {
        document.querySelector(".add-to-cart").click();
      });
  }
});
